import { useNavigate, useParams } from 'react-router-dom'
import {
  CloudMarketplace,
  Product,
  ProductStatus,
} from '../../../modules/productsListing/types'
import {
  actionTypeWrapper,
  excludedProductTypes,
  useAccountId,
  useCurrentCloudProvider,
} from '@labrav/common'
import { ButtonV2, PlanType } from '@labrav/react-components'

import { useDispatch } from 'react-redux'
import { setSelectedProductOnListing } from '../../../modules/productsListing/action'
import { useStyles } from './NoOfActiveContracts.styles'

export const NoOfActiveContracts = ({
  productRow,
  cloudType,
  hideContractLink,
}: {
  productRow: Product
  cloudType: CloudMarketplace
  hideContractLink: boolean
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { classes } = useStyles()
  const selectedCloudTypeProductListing = useCurrentCloudProvider()
  const { cloud: routeCloud, accountId: routeAccountId } = useParams<{
    cloud: string
    accountId: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId
  if (
    !productRow?.numberOfActiveContracts ||
    productRow?.status === ProductStatus.PRODUCT_STATUS_CREATION_FAILED
  ) {
    return '-'
  }

  if (hideContractLink) {
    return <>{productRow.numberOfActiveContracts.toString()}</>
  }
  const isDisable =
    cloudType === 'AWS'
      ? !excludedProductTypes.includes(productRow.productType as PlanType)
      : false
  const navigateToSubscriptions = async () => {
    if (!routeCloud || !accountId) return
    await dispatch(
      actionTypeWrapper(
        selectedCloudTypeProductListing,
        setSelectedProductOnListing(productRow.productId)
      )
    )
    navigate(`/flyout/${routeCloud}/${accountId}/subscriptions`)
  }
  return (
    <ButtonV2
      styleType="link"
      disabled={isDisable}
      data-testid={'no-of-active-contracts'}
      onClick={navigateToSubscriptions}
      className={classes.noOfContract}
    >
      {productRow.numberOfActiveContracts.toString()}
    </ButtonV2>
  )
}
